import { BrowserRouter } from 'react-router-dom'
import { useContext } from 'react'
import { Router } from './router'
import { useTokenAuth } from './hooks/useTokenAuth'
import { AuthProvider, AuthContext } from './contexts/AuthContext'
import { ErrorBoundary } from './components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

function AppContent() {
  const { isAuthenticating, error } = useTokenAuth();
  const authContext = useContext(AuthContext);

  // Show loading state if either token auth or auth context is loading
  const isLoading = isAuthenticating || authContext?.isLoading;

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-emerald-600 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center max-w-md">
          <div className="rounded-md bg-red-50 p-4">
            <h3 className="text-sm font-medium text-red-800">{error}</h3>
          </div>
          <a 
            href="/login" 
            className="mt-4 inline-block text-emerald-600 hover:text-emerald-500"
          >
            Go to login page
          </a>
        </div>
      </div>
    );
  }

  return <Router />;
}

export default App
